import React from 'react'
import Rectangle from '../rectangle'
import Shapes from '../shapes'

export const HeroOverlay = () => (
  <>
    {/* desktop screens */}
    <Shapes
      className="invisible hidden overflow-visible shapes-bottom-left lg:block lg:visible"
      width={225}
      height={50}
    >
      <Rectangle
        x={80}
        y={0}
        width={100}
        height={100}
        fill={`var(--color-brand-cyan)`}
        data-lax-translate-x="0 0, -680 (vw*0.6) | offset=-80 speed=0.6"
        data-lax-anchor="#hero"
      />
      <Rectangle
        x={180}
        y={100}
        width={45}
        height={45}
        fill={`var(--color-secondary)`}
        data-lax-translate-x="0 0, -680 (vw*0.6) | offset=-80 speed=0.6"
        data-lax-anchor="#hero"
      />
    </Shapes>
    <Shapes
      className="invisible hidden overflow-visible shapes-bottom-right lg:block lg:visible"
      width={360}
      height={25}
    >
      <Rectangle
        x={0}
        y={0}
        width={210}
        height={50}
        fill={`var(--color-brand-yellow)`}
        data-lax-translate-x="0 0, -680 (-vw*0.6) | offset=-80 speed=0.6"
        data-lax-anchor="#hero"
      />
    </Shapes>

    {/* mobile screens */}
    <Shapes
      className="visible overflow-visible shapes-bottom-left lg:hidden lg:invisible"
      width={130}
      height={25}
    >
      <Rectangle
        x={55}
        y={0}
        width={50}
        height={50}
        fill={`var(--color-brand-cyan)`}
        data-lax-translate-x="0 0, -331 (vw*0.6) | offset=-64 speed=0.6"
        data-lax-anchor="#hero"
      />
      <Rectangle
        x={105}
        y={50}
        width={25}
        height={25}
        fill={`var(--color-secondary)`}
        data-lax-translate-x="0 0, -331 (vw*0.6) | offset=-64 speed=0.6"
        data-lax-anchor="#hero"
      />
    </Shapes>
    <Shapes
      className="visible overflow-visible shapes-bottom-right lg:hidden lg:invisible"
      width={110}
      height={13}
    >
      <Rectangle
        x={0}
        y={0}
        width={83}
        height={26}
        fill={`var(--color-brand-yellow)`}
        data-lax-translate-x="0 0, -331 (-vw*0.6) | offset=-64 speed=0.6"
        data-lax-anchor="#hero"
      />
    </Shapes>
  </>
)

export const OurScaleOverlay = () => (
  <>
    {/* desktop screens */}
    {/* <Shapes
      className="invisible hidden overflow-visible shapes-left lg:block lg:visible"
      width={173}
      height={100}
    >
      <Rectangle
        x={53}
        y={-38}
        width={70}
        height={70}
        fill={`var(--color-secondary)`}
        data-lax-translate-x="(vh*0.6) -173, (vh*0.4) 0, 0 0 | offset=-80 speed=0.6"
        data-lax-anchor="#our-scale"
      />
      <Rectangle
        x={123}
        y={32}
        width={50}
        height={50}
        fill={`var(--color-brand-cyan)`}
        data-lax-translate-x="(vh*0.6) -173, (vh*0.4) 0, 0 0 | offset=-80 speed=0.6"
        data-lax-anchor="#our-scale"
      />
    </Shapes> */}
    {/* mobile screens */}
    <Shapes
      className="visible overflow-visible shapes-right lg:hidden lg:invisible"
      width={28}
      height={220}
    >
      <Rectangle
        x={0}
        y={192}
        width={28}
        height={28}
        fill={`var(--color-brand-cyan)`}
        data-lax-translate-x="(vh*0.6) 28, (vh*0.2) 0, 0 0 | offset=-64"
        data-lax-anchor="#our-scale"
      />
    </Shapes>
  </>
)

export const GroupCompaniesOverlay = () => (
  <>
    {/* desktop screens */}
    {/* <Shapes
      className="invisible hidden overflow-visible shapes-left lg:block lg:visible"
      width={173}
      height={100}
    >
      <Rectangle
        x={53}
        y={-38}
        width={70}
        height={70}
        fill={`var(--color-secondary)`}
        data-lax-translate-x="(vh*0.6) -173, (vh*0.4) 0, 0 0 | offset=-80 speed=0.6"
        data-lax-anchor="#group-companies"
      />
      <Rectangle
        x={123}
        y={32}
        width={50}
        height={50}
        fill={`var(--color-brand-cyan)`}
        data-lax-translate-x="(vh*0.6) -173, (vh*0.4) 0, 0 0 | offset=-80 speed=0.6"
        data-lax-anchor="#group-companies"
      />
    </Shapes> */}
    {/* mobile screens */}
    <Shapes
      className="visible overflow-visible shapes-left lg:hidden lg:invisible"
      width={83}
      height={13}
    >
      <Rectangle
        x={0}
        y={-13}
        width={83}
        height={26}
        fill={`var(--color-brand-yellow)`}
        data-lax-translate-x="(vh*0.6) -83, (vh*0.2) 0, 0 0 | offset=-64"
        data-lax-anchor="#our-scale"
      />
    </Shapes>
  </>
)
